// Onboarding module routes. Wired by router.tsx (owned by Phase 0); the
// user wires this export after Phase 1 + Phase 2 both land.

import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const CreateAccountPage = lazy(() =>
  import('./pages/CreateAccountPage').then((m) => ({ default: m.CreateAccountPage })),
);

export const onboardingRoutes: RouteObject[] = [
  { path: '/accounts/new', element: <CreateAccountPage /> },
];
